import { useContext } from "react";
import { roadContext } from "../context/Context";

const UseContext = () => {
  return useContext(roadContext);
};

export default UseContext;
